module.exports = __webpack_public_path__ + "media/images/about2-7ac1322f4872324f42e2dda2fcdeb950.jpg";